let _offscreenCanvas = null;
let _offscreenCtx = null;
const FJCanvasUtil = {
    /**
     * @desc 绘制格子色背景
     * @param {*} ctx
     * @param {*} width
     * @param {*} height
     */
    drawTransparentBackground: (ctx, width, height, size = 6) => {
        ctx.save();
        for (let y = 0; y < height; y += size) {
            for (let x = 0; x < width; x += size) {
                ctx.fillStyle = (x / size + y / size) % 2 === 0 ? '#ffffff' : '#cccccc';
                ctx.fillRect(x, y, size, size);
            }
        }
        ctx.restore();
    },
    createShader: (gl, type, source) => {
        const shader = gl.createShader(type);
        if (!shader) {
            throw new Error('Create shader fail!');
        }
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        const success = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
        if (success) {
            return shader;
        }

        console.error(gl.getShaderInfoLog(shader));
        gl.deleteShader(shader);
    },
    createTexture: gl => {
        const texture = gl.createTexture();
        if (!texture) {
            throw new Error('Create texture fail!');
        }
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, texture);

        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

        gl.bindTexture(gl.TEXTURE_2D, null);

        return texture;
    },
    fitSize: (innerSize, outerSize, float = true) => {
        let r1 = innerSize.width / innerSize.height;
        let r2 = outerSize.width / outerSize.height;
        let w, h;
        if (r1 >= r2) {
            w = outerSize.width;
            h = w / r1;
        } else {
            h = outerSize.height;
            w = h * r1;
        }
        if (float) {
            return { width: w, height: h };
        } else {
            return { width: Math.floor(w), height: Math.floor(h) };
        }
    },
    couldOptFrame() {
        return typeof createImageBitmap !== 'undefined' && typeof OffscreenCanvas !== 'undefined';
    },
    getImageBitmap(canvas) {
        const width = canvas.width;
        const height = canvas.height;
        _offscreenCanvas = _offscreenCanvas || new OffscreenCanvas(width, height);

        if (_offscreenCanvas.width !== width) {
            _offscreenCanvas.width = width;
        }
        if (_offscreenCanvas.height !== height) {
            _offscreenCanvas.height = height;
        }
        _offscreenCtx = _offscreenCtx || _offscreenCanvas.getContext('2d');
        if (_offscreenCtx) {
            _offscreenCtx.drawImage(canvas, 0, 0, width, height);
            return _offscreenCanvas.transferToImageBitmap();
        }
        return null;
    },
};

export default FJCanvasUtil;
